import script from "./AtomSwich.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomSwich.vue?vue&type=script&lang=ts&setup=true"

import "./AtomSwich.vue?vue&type=style&index=0&id=5e7bc122&lang=css"

const __exports__ = script;

export default __exports__